import { PAGINGATION_DEFAULT, QUERY_PAGING } from '@const/pagination'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchAmbassadorList } from './asyncAction'

const initalFetchListParams: TAmbassadorManagementAPI.Params.FetchList = {
  createdDateTo: '',
  createdDateFrom: '',
  customerEmailFilter: '',
  ...QUERY_PAGING
}
const initialState: TAmbassadorManagement.TState = {
  ambassadorList: {
    data: [],
    ...PAGINGATION_DEFAULT
  },
  isFetchingAmbassadorList: true,
  searchParams: initalFetchListParams,
  isDownloadingFile: false
}
const injectAmbassadorManagementSlice = createSlice({
  name: 'ambassadorManagement',
  initialState,
  reducers: {
    setFromDateValue (state, action) {
      state.searchParams.createdDateFrom = action.payload
    },
    setToDateValue (state, action) {
      state.searchParams.createdDateTo = action.payload
    },
    setIsDownloadingFile (state, action) {
      state.isDownloadingFile = action.payload
    },
    setSearchParamCustomerId (state, action) {
      state.searchParams.customerEmailFilter = action.payload
    },
    setPageIndex (state, action) {
      state.searchParams.PageIndex = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAmbassadorList.fulfilled, (state, action: PayloadAction<TAmbassadorManagement.TState['ambassadorList']>) => {
        if (!action.payload?.data) return
        state.ambassadorList = {
          ...action.payload
        }
        state.isFetchingAmbassadorList = false
      })
      .addCase(fetchAmbassadorList.pending, state => {
        state.isFetchingAmbassadorList = true
      })
  }
})

export * from './asyncAction'

export const {
  setFromDateValue,
  setToDateValue,
  setIsDownloadingFile,
  setSearchParamCustomerId,
  setPageIndex
} = injectAmbassadorManagementSlice.actions

export const ambassadorManagementReducer = injectAmbassadorManagementSlice.reducer
